import { c as _c } from "react/compiler-runtime";
import { SectionHeadline } from '@/components/SectionHeadline';
import { FilledButton } from '@/components/buttons';
import type { FilledButtonProps } from '@/components/buttons';
import { Text } from '@/components/typography';
import { mergeClasses } from '@/utils/style';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
interface Props {
  buttons: Array<FilledButtonProps>;
  className?: string;
  subtitle?: string;
  title?: string;
  footer?: ReactNode;
  anchorKey?: string;
}
export function MoreInfoButtons(props) {
  const $ = _c(7);
  const {
    className,
    buttons
  } = props;
  let t0;
  if ($[0] !== className) {
    t0 = mergeClasses("m-auto mt-10 flex w-70 flex-wrap items-center justify-center gap-2 lg:mt-16 lg:w-192 lg:gap-4", className);
    $[0] = className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== buttons) {
    t1 = buttons.map(_temp);
    $[2] = buttons;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <div className={t0}>{t1}</div>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp(button, id) {
  return <FilledButton key={id} analyticsParam={button.analyticsParam} icon={button.icon} testId={button.testId} to={button.to}>{button.title}</FilledButton>;
}
function MoreInfo(t0) {
  const $ = _c(21);
  const {
    buttons,
    className,
    subtitle,
    title,
    footer,
    anchorKey: t1
  } = t0;
  const anchorKey = t1 === undefined ? "core.moreInfoSectionTitle" : t1;
  const {
    t
  } = useTranslation("core");
  let t2;
  if ($[0] !== className) {
    t2 = mergeClasses("w-full py-14 lg:pt-20 lg:pb-26", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = title ? "mb-4" : "mb-10 lg:mb-16";
  let t4;
  if ($[2] !== t3) {
    t4 = mergeClasses(t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t || $[5] !== title) {
    t5 = title || t("moreInfoSectionTitle");
    $[4] = t;
    $[5] = title;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== anchorKey || $[8] !== t4 || $[9] !== t5) {
    t6 = <SectionHeadline className={t4} anchorKey={anchorKey}>{t5}</SectionHeadline>;
    $[7] = anchorKey;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== subtitle) {
    t7 = subtitle && <Text variant="p2" className="mt-5 text-center text-gray-800">{subtitle}</Text>;
    $[11] = subtitle;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== buttons) {
    t8 = <MoreInfoButtons buttons={buttons} />;
    $[13] = buttons;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== footer || $[16] !== t2 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <div className={t2}>{t6}{t7}{t8}{footer}</div>;
    $[15] = footer;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
export default MoreInfo;